import React from 'react';

export const ButtonControl = ({ field } : ControlParameters) : JSX.Element => {

  return (
    <div className="form-group">
      <div className="d-flex flex-row">
        <a id={field["@column"]} className={field.properties?.fieldcssclass} href={field.settings.Href}>{field.properties.fieldcaption}</a>
      </div>
    </div>
  );
};